import { render } from "./TContratoCrear.vue?vue&type=template&id=d45ddeba"
import script from "./TContratoCrear.vue?vue&type=script&lang=js"
export * from "./TContratoCrear.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__